<template>
  <div class="item-title">
    {{ $t("Coupon.couponCode") }}
  </div>
  <div class="item-content">
    <div class="code">
      {{ code }}
    </div>
    <div class="copy-btn">
      <button @click="copyCoupon(code)">
        {{ $t("Coupon.copy") }}
      </button>
    </div>
  </div>

  <DialogCopyCoupon ref="DialogCopyCoupon" />
</template>

<script>
import nativeHandlerService from "@/services/nativeHandler";
import { ref } from "vue";

export default {
  name: "TheCouponCode",
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isLocal = process.env.NODE_ENV === "local";

    const DialogCopyCoupon = ref(null);

    const copyCoupon = (code) => {
      if (isLocal) {
        navigator.clipboard.writeText(code);
      } else {
        nativeHandlerService.copyCoupon(code);
      }

      DialogCopyCoupon.value.openDialog();
    };

    return {
      copyCoupon,
      DialogCopyCoupon,
    };
  },
};
</script>

<style scoped lang="scss">
.item-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 15px;
}

.item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .code {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  .copy-btn {
    > button {
      width: 74px;
      height: 36px;
      border-radius: 4px;
      background: white;
      border: 1px solid #000;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #000;
    }
  }
}
</style>
